import './jquery-import.js';
import { Collapse as Collapse, Dropdown as Dropdown, Modal as Modal } from 'bootstrap';
import * as commonLib from './common.js';
import {loadLForms, getSupportedLFormsVersions, changeLFormsVersion} from 'lforms-loader';
import {initSidebar} from './lhcforms-demo/left-sidebar';
import {spinner} from './spinner.js';
import {show} from './util.js';

commonLib.setCurrentPage('lhcformsLink');

/**
 *  Initialiation that should happen after LForms has been loaded.
 */
function postLFormsInit() {
  initSidebar();
  spinner.hide();
  show(document.getElementById('postLoadContent'));
}



let params = new URL(document.location).searchParams;
let lformsVersion = params.get('lfv');
spinner.show();
if (lformsVersion)
  loadLForms(lformsVersion).then(()=>postLFormsInit(), e=>{
    spinner.hide();
    const errMsgElem = document.getElementById('preLoadErrMsg');
    errMsgElem.textContent =
      'Unable to load LHC-Forms.  See the console for details.';
    show(errMsgElem);
    console.log('Unable to load LHC-Forms version '+lformsVersion);
    console.log(e);
  });
else {
  getSupportedLFormsVersions().then(versions=>{
    loadLForms(versions[0]).then(()=>postLFormsInit(), e=>{
      // Some file failed to load.
      console.log(e);
      // Try the next most recent version
      changeLFormsVersion(versions[1]);
    });
  });
}
